import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { IdRandomPools } from "../../constants/IdRandomPools";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { selectRewardsListPoolContentResources, } from "../../selectors/selectDoghouseInfo";
import { selectFortuneTellerEventPackageDetails } from "../../selectors/selectFortuneTellerEventInfo";
import { selectIsModalOpen, selectModalTabId } from "../../selectors/selectModalTabId";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { List } from "../generic/list/List";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { DoghouseCategory } from "./DoghouseCategory";
import { DoghouseRewardListItem } from "./DoghouseRewardListItem";
var DialogDoghouseShowAllRewardsDOM = function (_a) {
    var onClose = _a.onClose, rewardResources = _a.rewardResources;
    var renderItem = function (resource) { return (React.createElement(DoghouseRewardListItem, { key: "doghouse-reward-" + resource.typeId, resource: resource })); };
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.possibleRewards, onClose: onClose, className: IdStyles.ModalBackgroundResources },
        React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
            React.createElement(List, { className: "dog-house-reward-list-container", items: rewardResources, renderItem: renderItem }))));
};
var mapState = function (state) {
    var isFortuneTellerModalOpen = selectIsModalOpen(state, IdModal.FortuneTellerEvent);
    var doghouseMenuSelectedTab = selectModalTabId(state, IdModal.Doghouse);
    var poolId = isFortuneTellerModalOpen
        ? selectFortuneTellerEventPackageDetails(state).randomPoolRewardId
        : doghouseMenuSelectedTab === DoghouseCategory.GiveDoghouseBone
            ? IdRandomPools.DogPoolStandard
            : IdRandomPools.DogPoolPremium;
    return {
        rewardResources: selectRewardsListPoolContentResources(state, poolId),
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ShowAllRewards)); },
}); };
export var DialogDoghouseShowAllRewards = connect(mapState, mapDispatch)(DialogDoghouseShowAllRewardsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DialogDoghouseShowAllRewards.tsx
// module id = 2818
// module chunks = 3